import { Tile } from "./TileDisplay";
import { ResponsiveChartContainer, LinePlot, LineSeriesType, ChartsXAxis, ChartsTooltip, ChartsLegend, ChartsYAxis } from '@mui/x-charts';
import moment from 'moment';
import { WithTitle } from "./TileDisplay";
import { ChartsOverlay } from "@mui/x-charts/ChartsOverlay";

export function LineChart({ tile, valueKeys }: { tile: Tile; valueKeys: string[] }) {

    const lineSeries: LineSeriesType[] = valueKeys.map(key => ({
        type: 'line',
        label: key,
        dataKey: key,
        showMark: true
    }));

    return <>
        <WithTitle title={tile.title}>
            <div style={{ width: '100%', height: 250 }}>
                <ResponsiveChartContainer
                    xAxis={[
                        {
                            dataKey: 'timestamp',
                            id: 'x-axis-id',
                            scaleType: 'point',
                            valueFormatter: (value: string) => moment(new Date(value)).format('lll'),
                        }
                    ]}
                    yAxis={[
                        { id: 'y-axis-id', scaleType: 'linear' },
                    ]}
                    series={lineSeries}
                    dataset={tile.data}>
                    <LinePlot />
                    <ChartsOverlay slotProps={tile.data.length === 0 ? {noDataOverlay: {message: 'No data in this time range'}} : {}} />
                    <ChartsXAxis label="Time" position="bottom" axisId="x-axis-id" />
                    <ChartsYAxis label="Y axis" position="left" axisId="y-axis-id" />
                    <ChartsTooltip trigger='axis' />
                    <ChartsLegend position={{ horizontal: 'right', vertical: 'top' }} />
                </ResponsiveChartContainer>
            </div>
        </WithTitle>
    </>
}